import React, { useEffect, useState } from "react";
import { listWorkspaces, Workspace } from "../lib/plbxApi";

type Props = {
  active: string | null;
  onSelect: (workspaceId: string) => void;
};

export const WorkspaceSwitcher: React.FC<Props> = ({ active, onSelect }) => {
  const [items, setItems] = useState<Workspace[]>([]);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    listWorkspaces()
      .then((res) => setItems(res.data))
      .catch((e) => setErr(String(e?.message ?? e)));
  }, []);

  if (err) {
    return <aside className="plbx-ws-switcher plbx-ws-switcher--error">{err}</aside>;
  }

  const shared = items.filter((w) => w.kind === "shared");
  const personal = items.filter((w) => w.kind === "personal");

  const row = (w: Workspace) => (
    <li
      key={w.id}
      className={`plbx-ws-row${active === w.id ? " plbx-ws-row--active" : ""}`}
      onClick={() => onSelect(w.id)}
    >
      <span className="plbx-ws-row__name">{w.name}</span>
      <span className="plbx-ws-row__count">{w.sceneCount}</span>
    </li>
  );

  return (
    <aside className="plbx-ws-switcher">
      <header className="plbx-ws-switcher__header">WORKSPACES</header>
      <ul className="plbx-ws-switcher__list">{shared.map(row)}</ul>
      {personal.length > 0 && <hr className="plbx-ws-switcher__sep" />}
      <ul className="plbx-ws-switcher__list">{personal.map(row)}</ul>
      <footer className="plbx-ws-switcher__footer">
        <a href="https://id.plbx.ai" target="_blank" rel="noreferrer">
          manage in id.plbx.ai
        </a>
      </footer>
    </aside>
  );
};

export default WorkspaceSwitcher;
